var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedRegularFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 292.94 340.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#207d8c;}.cls-2{fill:#ee2c51;}.cls-3{fill:#8b191e;}.cls-4{fill:none;stroke:#ed2024;stroke-miterlimit:10;stroke-width:0.99px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.94,30.33c0-7.17-3.08-9.86-10.5-9.94s-1.63-.05-12.15,0c-9.62,0-10.47-6.6-10.47-6.6s-1-6.26-8.79-6.28-233,0-233,0a8,8,0,0,0-8,8V332.87a8,8,0,0,0,8,8H284.94a8,8,0,0,0,8-8S292.93,37.51,292.94,30.33ZM251.11,284a6,6,0,0,1-6,6H39a6,6,0,0,1-6-6V109.56a6,6,0,0,1,6-6H245.11a6,6,0,0,1,6,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.52,22.84c0-7.18-3.08-9.86-10.5-9.95s-1.64,0-12.16,0c-9.62,0-10.46-6.6-10.46-6.6S250.36,0,242.61,0s-233,0-233,0a8,8,0,0,0-8,8V325.38a8,8,0,0,0,8,8H276.52a8,8,0,0,0,8-8S284.5,30,284.52,22.84ZM251.11,284a6,6,0,0,1-6,6H39a6,6,0,0,1-6-6V109.56a6,6,0,0,1,6-6H245.11a6,6,0,0,1,6,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.64,325.38A8,8,0,0,0,7.3,333V119.27H1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M278.62,119.27V333.09a8,8,0,0,0,5.9-7.71s0-117.53,0-206.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.78,54.1A24.54,24.54,0,0,1,229.15,79l-174.67-.2a25.48,25.48,0,0,1-25.36-24.9A24.53,24.53,0,0,1,53.75,29l174.66.19A25.5,25.5,0,0,1,253.78,54.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 12.91,
    width: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.52,40.84v-4h-32a28.56,28.56,0,0,1,2.42,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.64,36.84v4H27.53a27.53,27.53,0,0,1,2.25-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.64,44.78v4H25.31a26.7,26.7,0,0,1,.79-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.52,48.78v-4h-28a28,28,0,0,1,.94,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.12,52.6H1.64v4H25.2c0-.44,0-.87-.05-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M257.79,55.58c0,.34,0,.68,0,1h26.75v-4H257.75v.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.64,60.41v4H26.85a27,27,0,0,1-1.14-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.52,64.41v-4H257.41a26.57,26.57,0,0,1-1,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.52,71.65v-4h-29.4a27.22,27.22,0,0,1-2.38,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.64,67.65v4H30.82a27.56,27.56,0,0,1-2.53-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M254.62,108.2a8,8,0,0,0-8-8H37.48a8,8,0,0,0-8,8L30,285.25a8,8,0,0,0,8,8H247.16a8,8,0,0,0,8-8ZM251.11,284a6,6,0,0,1-6,6H39a6,6,0,0,1-6-6V109.56a6,6,0,0,1,6-6H245.11a6,6,0,0,1,6,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.08,318a5,5,0,0,0,7.81,0l11-12.79c2.15-2.51,1.21-4.56-2.09-4.56H130.19c-3.3,0-4.24,2.05-2.09,4.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedRegularFace);
export default __webpack_public_path__ + "static/media/red-regular-face.94d20130ef09fa192ab3fca8b4fad235.svg";
export { ForwardRef as ReactComponent };